(function () {
    'use strict';

    angular.module('app.layout', [
        'app.registration',

        'app.core',
        'app.access'
    ]);
})();